import { useShortIdContext } from '@air/provider-short-id';

import { useAssetNavigationHotkeys } from '~/components/AssetModalV2/hooks/useAssetNavigationHotkeys';
import { useGoToPublicAssetPage } from '~/hooks/useGoToPublicAssetPage';
import { usePublicMediaPlayerData } from '~/swr-hooks/mediaPlayer/usePublicMediaPlayerData';

export const usePublicAssetNavigationHotkeys = (enabled = true) => {
  const { shortId } = useShortIdContext();
  const { goToAssetPage } = useGoToPublicAssetPage();
  const { loadMore, nextAsset, previousAsset, isNearEnd } = usePublicMediaPlayerData(shortId);

  return useAssetNavigationHotkeys({
    goToAssetPage,
    loadMore,
    nextAsset,
    previousAsset,
    isNearEnd: isNearEnd ?? false,
    enabled,
  });
};
